<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Manage Tasks</h5>
  </div>
<div id="mainContent" class="container">
  <div class="row pt-3">
    <div class="col-md-10 offset-md-1" style="">
      <button id="addTaskBtn" name="addTaskBtn" mat-raised-button class="btn-theme" style="float:right" matTooltip="Click to add assignment" matTooltipPosition="left"
    (click)="openModal(modalContent,'add')">
        <i class="fa fa-plus-square" aria-hidden="true"></i>&nbsp;&nbsp; Task
    </button>
    </div>
  </div>
  <div class="pt-2 pb-2">
    <div class="col-md-12">
      <table class="table table-striped table-bordered table-sm">
        <thead class="">
          <tr>
            <th scope="col">Sr.No.</th>
            <th scope="col">Name</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let task of taskList; index as i" id="task_{{i+1}}">
            <td scope="row">{{i+1}}</td>
            <td>{{task.name}}</td>
            <td>
              <button id="editTaskBtn_{{i+1}}" name="editTaskBtn_{{i+1}}" class="btn btn-sm btn-outline-theme"  (click)="onEditClick(modalContent,task)"
              matTooltip="Click to edit" matTooltipPosition="above">
                <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
              </button> &nbsp;&nbsp;
              <button id="deleteTaskBtn_{{i+1}}" name="deleteTaskBtn_{{i+1}}" class="btn btn-sm btn-outline-danger" (click)="onDeleteClick(task)"
              matTooltip="Click to delete" matTooltipPosition="above">
                <i class="fa fa-trash-o" aria-hidden="true"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  </div>
</div>


  <!-- Modal Template -->
  <ng-template #modalContent let-modal>
    <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
      <h5 class="modal-title" id="modal-basic-title">Task</h5>
    </div>
    <div class="modal-body">
        <!-- {{assignmentList | json}} -->
      <form [formGroup]="modalForm">
        <div class="row">
          <label class="col-sm-4">Task Name :</label>
          <div class="col-sm-8">
          <input id="name" name="name" type="text" class="form-control form-control-xs"
           formControlName="name" [class.is-invalid]="formErrors.name && formSubmitted">
          </div>
          </div>
          <div class="row">

            <label class="col-sm-4">Assignments :</label>
            <div class="col-sm-8">
            <!-- <input id="assignments" name="assignments" type="text" class="form-control form-control-xs"
             formControlName="assignments" [class.is-invalid]="formErrors.assignments && formSubmitted"> -->
             <mat-form-field appearance="legacy" style="width:300px;">
              <!-- <mat-label>Assignments</mat-label> -->
              <mat-select formControlName="assignments" multiple [compareWith]="compareItems">
                <!-- <mat-option [value]="1" (click)="selectAll(ev)" #ev >SelectAll</mat-option> -->
                <mat-option #item *ngFor="let assignment of assignmentList" [value]="assignment">{{assignment.name}}</mat-option>
              </mat-select>
            </mat-form-field>
            </div>
            </div>
      </form>
    </div>
    <div class="modal-footer" style="">
      <div class="row col-md-12">
          <div class="col-sm-6"></div>
          <div class="col-sm-3">
              <button id="saveTaskBtn" name="saveTaskBtn" type="button" *ngIf="modalStatus=='add'" class="btn btn-sm btn-block btn-outline-theme" (click)="onSaveClick()">Save</button>
              <button id="updateTaskBtn" name="updateTaskBtn" type="button" *ngIf="modalStatus=='edit'" class="btn btn-sm btn-block btn-outline-theme" (click)="onUpdateClick()">Update</button>
          </div>
          <div class="col-sm-3">
            <button id="closeTaskBtn" name="closeTaskBtn" type="button" class="btn btn-sm btn-block btn-outline-secondary" (click)="modal.dismiss('Cross click')">Close</button>
        </div>
      </div>
  </div>
  </ng-template>
